import { render, staticRenderFns } from "./part-list.vue?vue&type=template&id=532bf86b&scoped=true"
import script from "./part-list.vue?vue&type=script&lang=js"
export * from "./part-list.vue?vue&type=script&lang=js"
import style0 from "./part-list.vue?vue&type=style&index=0&id=532bf86b&prod&lang=css"
import style1 from "./part-list.vue?vue&type=style&index=1&id=532bf86b&prod&scoped=true&lang=css"
import style2 from "./part-list.vue?vue&type=style&index=2&id=532bf86b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532bf86b",
  null
  
)

export default component.exports